<script lang="ts">
    import type { TagNodeObject } from '$lib/bbcode/parser/types';
    import * as z from 'zod';
    import BBCodeTree from '$components/BBCode/BBCodeTree.svelte';

    export let node: TagNodeObject;

    const zAttrs = z.object({
        style: z.string().nullish(),
    });

    $: attrs = zAttrs.parse(node.attrs);
</script>

<ul class={`list-${attrs.style ?? 'default'}`}>
    <BBCodeTree nodes={node.content} let:slotName let:slotContent>
        <slot {slotName} {slotContent} />
    </BBCodeTree>
</ul>
